import { Tile } from '../../atom.tile/_tile-input.js';
import { tile } from './atom.tile.style.js';
import { jsx } from 'react/jsx-runtime';

function TransparentImageOnImageTile(props) {
  return /*#__PURE__*/jsx(Tile, {
    className: tile,
    tile: props.tile,
    state: props.state,
    preferredFlow: props.preferredFlow,
    isDraggable: !!props.isDraggable,
    isDragOverlay: !!props.isDragOverlay
  });
}

export { TransparentImageOnImageTile };
//# sourceMappingURL=atom.tile.js.map
